import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';

import { IconSvg, Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { Section } from 'components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#162C3C',
  },
  image: {
    // minHeight: 400,
    // height: 250,
    objectFit: 'cover',
  },
  heroIcon: {
    fontSize: 250,
    fill: '#040505',
    opacity: 0.2,
    // filter: 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7))',
    [theme.breakpoints.down('md')]: {
      opacity: 0.05,
    },
  },
  textWhite: {
    color: 'white',
  },
  title: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  section: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    paddingTop: 0,
    paddingBottom: 0,
    [theme.breakpoints.down('sm')]: {
      // height: '100%',
      overflowY: 'auto',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  sectionIcon: {
    left: -25,
    top: 0,
    transform: 'scale(1.8)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const HeroImageBackground = props => {
  const {
    className,
    backgroundImg,
    backgroundIcon,
    title,
    height: propHeight,
    mobileHeight,
    children,
    classes: propClasses = {},
  } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  });

  const height = (isMd ? mobileHeight : propHeight) || propHeight || 200;

  return (
    <div className={clsx(classes.root, className)} style={{ height }}>
      <Image
        lazy={false}
        src={backgroundImg}
        srcSet={backgroundImg}
        alt={title}
        className={classes.image}
        lazyProps={{
          width: '100%',
          height: '100%',
        }}
      />
      <div
        className={clsx(classes.section, classes.sectionIcon)}
        style={{ left: -height / 10 }}
      >
        <IconSvg
          className={classes.heroIcon}
          style={{ fontSize: height }}
          name={backgroundIcon}
          viewBox="0 0 1080 1080"
        />
      </div>
      <Section className={classes.section}>
        <>
          {title && (
            <SectionHeader
              title={title}
              titleProps={{
                className: clsx(
                  classes.title,
                  classes.textWhite,
                  propClasses.title,
                ),
                variant: 'h2',
              }}
              align="left"
              // data-aos="fade-up"
            />
          )}
          {children && <div>{children}</div>}
        </>
      </Section>
    </div>
  );
};

HeroImageBackground.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Background image of the hero
   */
  backgroundImg: PropTypes.string.isRequired,
  /**
   * Background svg icon in the image
   */
  backgroundIcon: PropTypes.string.isRequired,
  /**
   * Title in the hero
   */
  title: PropTypes.string,
  /**
   * Hero height in px
   */
  height: PropTypes.number.isRequired,
  /**
   * Hero height in px when mobile fallback in `height`
   */
  mobileHeight: PropTypes.number,
  /**
   * SVG icon to inject to left if the hero
   */
  heroIcon: PropTypes.string,
  /**
   * Children to placed inside the hero.
   */
  children: PropTypes.node,
};

export default HeroImageBackground;
